module.exports = __webpack_public_path__ + "img/接受与登记机构.b24416ec.png";